import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { TermModel,ServiceTypeModel } from '../../../_models/_index';
import { GeneralService, TermOfUseService,InfraService } from '../../../services/_index';

@Component({
  selector: 'app-terms-of-use-page',
  templateUrl: './terms-of-use-page.component.html',
  styleUrls: ['./terms-of-use-page.component.css']
})
export class TermsOfUsePageComponent implements OnInit {
    terms: TermModel;
    serviceTypeID: number = null;
    serviceTypeList: ServiceTypeModel[];    
    constructor(private termOfUseService: TermOfUseService,
        private generalService: GeneralService,
        private infraService: InfraService,
       ) {
        this.terms = new TermModel();
    }

    ngOnInit() {
        this.loadServiceType();
    }

    loadData() {
        this.termOfUseService.getTerms(this.serviceTypeID).then(result => {
            this.terms = result;
        });
    }

    save()
    {
        this.termOfUseService.editTerm(this.terms).then(res =>
        {
            if (res) 
            {
                this.generalService.showSnackBar("תנאי שימוש נשמרו בהצלחה!");
            }
        });
    }

    typeChange() {
        
        this.loadData();
    }

    loadServiceType() {
        
            this.infraService.getServiceType().then(result => {
                this.serviceTypeList = result;
                this.serviceTypeID = this.serviceTypeList[0].id;
                this.loadData();
            });
        
    }

}



// WEBPACK FOOTER //
// ./src/app/components/terms-of-use/terms-of-use-page/terms-of-use-page.component.ts